<nb-card>
    <nb-card-header>
        {{ voucher.title }} | {{ voucher.code }}
    </nb-card-header>

    <nb-card-body>

    </nb-card-body>

    <nb-card-footer>
        <ng-content></ng-content>
    </nb-card-footer>
</nb-card>